/*
  CpanelLoginDialog

    Displays a modal dialog to user stating that user deleted the default username required for auto-login. So need to click below button to log in manually.
    It will redirect to the Cpanel login page when user clicks Continue button.

*/
import { useTranslation } from 'react-i18next';

import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ResponsiveDialog, {
  StyledButton,
  StyledLoadingButton,
} from '~/components/ResponsiveDialog';

type CpanelLoginDialogProps = {
  isOpen: boolean;
  title: string;
  ipAddress?: string | null;
  description?: string;
  backAction: VoidFunction;
};

const CpanelLoginDialog = ({
  isOpen,
  title,
  ipAddress = undefined,
  description = '',
  backAction,
}: CpanelLoginDialogProps) => {
  const { t } = useTranslation(['common', 'quickLinks']);

  const redirectToLoginUrl = async () => {
    const cPanelLoginPage = `https://${ipAddress}:2083`;
    var ssoWindow = window.open(cPanelLoginPage, '_blank');

    if (!ssoWindow) return;
    backAction();
  };

  return (
    <ResponsiveDialog open={isOpen}>
      <DialogContent>
        <Typography variant="h2">{title}</Typography>
        <Divider variant="fullWidth" sx={{ m: 1, p: 0 }} />
        <Stack direction="column" spacing={2}>
          <Typography>{description}</Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <StyledButton
          variant="text"
          onClick={backAction}
          data-testid="mcmd-cancel"
        >
          {t('actions.cancel')}
        </StyledButton>
        <StyledLoadingButton
          variant="contained"
          onClick={() => redirectToLoginUrl()}
          data-testid="cpanellogin-continue-button"
        >
          {t('actions.continue', { ns: 'common' })}
        </StyledLoadingButton>
      </DialogActions>
    </ResponsiveDialog>
  );
};

export default CpanelLoginDialog;
